<template>
  <section :class="{ desktop: $isDesktop }">
    <fieldset class="byo">
      <translate tag="legend"> Bring my own </translate>
      <div>
        <pu-search-link
          v-for="accommType of categoriesData.slice(0, 3)"
          v-bind="accommType.to"
          :key="accommType.name"
          :modify-filters="modifiedLinkFilters"
          class="card"
          exclude-type="newCategoryNoSort"
        >
          <img
            v-if="accommType.iconUrl"
            :src="accommType.iconUrl"
            :alt="accommType.name"
            class="icon"
            width="20"
            height="20"
          />
          <span>{{ accommType.name }}</span>
        </pu-search-link>
      </div>
    </fieldset>
    <fieldset class="onsite">
      <translate tag="legend"> Onsite accommodation </translate>
      <div>
        <pu-search-link
          v-for="accommType of categoriesData.slice(3)"
          v-bind="accommType.to"
          :key="accommType.name"
          :modify-filters="modifiedLinkFilters"
          class="card"
          exclude-type="newCategoryNoSort"
        >
          <img
            v-if="accommType.iconUrl"
            :src="accommType.iconUrl"
            :alt="accommType.name"
            :class="accommType.to.category"
            width="20"
            height="20"
          />
          <span>{{ accommType.name }}</span>
        </pu-search-link>
      </div>
    </fieldset>
  </section>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'

interface AccommodationType {
  name: string
  to: { facet?: string; category: string }
  iconUrl?: string
}

@Component
class AccommodationTypes extends Vue {
  @Prop({ required: true })
  categoriesData: AccommodationType[]

  get modifiedLinkFilters() {
    return {
      hierarchyPath: undefined,
      facets: undefined,
      page: undefined,
      sort: undefined,
    }
  }
}

export default toNative(AccommodationTypes)
</script>

<style scoped>
section {
  padding: 0 1.1em;
}

fieldset {
  border: 3px solid var(--colour-page-background);
  border-radius: 0.65em;
  padding: 1em 0.5em 0.75em;
}

legend {
  font-size: var(--body);
  color: var(--colour-dark-blue);
  font-weight: bold;
  padding: 0 0.4em;
  margin-left: 0.4em;
}

fieldset div {
  align-items: baseline;
  column-gap: 1em;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  row-gap: 0.5em;
}

a {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  text-decoration: none;
  font-size: 0.8em;
  color: var(--colour-dark-blue);
  line-height: 1.15em;
  text-align: center;
}

fieldset.byo a {
  max-width: 33%;
}

fieldset.onsite a {
  width: calc(50% - 1em);
}

a img {
  width: auto;
  height: 2.5em;
  margin: 0 0 0.5em 0;
}

img.glamping {
  height: 2.4em;
}

/* mobile landscape */
@media screen and (min-width: 320px) and (max-width: 998px) and (orientation: landscape) {
  section {
    display: flex;
    column-gap: 2em;
    justify-content: space-evenly;
  }
}

/* desktop & tablet */
section.desktop {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: space-around;
  padding: 0;
  column-gap: 4em;
}

.desktop a {
  font-size: 1.5em;
}

.desktop a {
  transition:
    box-shadow 0.15s ease-out,
    transform 0.25s ease-out;
  border-radius: 0.75em;
  padding: 0.75em;
}

.desktop a:hover,
.desktop a:focus-visible {
  box-shadow: 0 0 0 7px var(--focus-ring-colour);
  transform: scale(1.05);
  outline: none;
}

.desktop fieldset {
  border-width: 7px;
  border-color: var(--colour-page-background-light);
  border-radius: 1.5em;
  padding: 2em;
  flex-basis: 50%;
}

.desktop fieldset div {
  max-width: none;
  gap: 0.75em;
}

.desktop fieldset.byo div {
  flex-wrap: wrap;
  justify-content: center;
}

.desktop fieldset.onsite a,
.desktop fieldset.byo a {
  max-width: none;
  width: auto;
  min-width: 10em;
}

.desktop legend {
  font-size: 1.5em;
  padding: 0 0.5em;
  margin-left: 1em;
}
</style>
